module.exports = __webpack_public_path__ + "img/bottom_tab_item_sel.04a9ba05.png";